import React from "react";
import { Button, TextField } from "@mui/material";
import { injectIntl, MessageDescriptor } from "react-intl";
import { NumberButton } from "./NumberButton";
import { IReactIntlProps } from "../../views/common";

interface NumpadProps extends IReactIntlProps {
    hintMessage: MessageDescriptor;
    onNumberCompleted: (value: string) => void;
    autoComplete: number;
}

interface NumpadState {
    number?: string;
    hidden?: boolean;
}

class Numpad extends React.PureComponent<NumpadProps, NumpadState> {

    constructor(props) {
        super(props);
        this.state = { number: "", hidden: false };
    }

    componentDidMount(): void {
        document.addEventListener("keydown", this.onKeyDown);
    }

    componentWillUnmount(): void {
        document.removeEventListener("keydown", this.onKeyDown);
    }

    clearClicked = (): void => {
        let enteredNumber = this.state ? this.state.number : "";

        if (enteredNumber === "000") {
            this.setState({ number: "", hidden: true });
        } else {

            if (enteredNumber.length > 0) {
                enteredNumber = enteredNumber.substr(0, enteredNumber.length - 1);
            }

            this.setState({ number: enteredNumber });
        }

        if (this.state.hidden) {
            this.setState({ number: "", hidden: false });
        }
    };

    okClicked = (): void => {
        if (this.state.hidden && this.state.number === "730403") {
            this.props.onNumberCompleted("showsettings");
        } else {
            this.enterNumberIsDone(this.state ? this.state.number : "");
        }
    };

    onKeyDown = (event: KeyboardEvent): void => {
        const number = Number(event.key);

        if (event.key === "Backspace") {
            this.clearClicked();
        } else if (event.key === "Enter") {
            this.okClicked();
        } else if (!isNaN(number)) {
            this.numberClicked(number.toString());
        }
    };

    numberClicked = (label: string): void => {
        const newNumber = (this.state ? this.state.number : "") + label;

        if (this.isAutoCompleted(newNumber)) {
            this.enterNumberIsDone(newNumber);
        } else {
            this.setState({ number: newNumber });
        }
    };

    enterNumberIsDone(number: string): void {
        if (number.length === 0) {
            return;
        }

        this.props.onNumberCompleted(number);
        this.setState({ number: "" });
    }

    isAutoCompleted(number: string): boolean {
        if (this.props.autoComplete === 0) {
            return false;
        }

        let serviceCode = "730403";
        const charsToRemove = serviceCode.length - this.props.autoComplete;
        serviceCode = serviceCode.slice(0, charsToRemove);

        const notServiceCode = number !== "000" && number !== serviceCode && number !== "730403".slice(0, number.length);
        return number.length >= this.props.autoComplete && notServiceCode;
    }

    render(): React.ReactNode {
        const { number, hidden } = this.state;
        const { intl, hintMessage } = this.props;

        return (
            <div className="entry">
                <TextField
                    className="id-input"
                    value={number ? number : intl.formatMessage(hintMessage)}
                    variant="outlined"
                    type={hidden ? "password" : undefined}
                />
                <div className="Numpad">
                    <NumpadRow values={["1", "2", "3"]} onClick={this.numberClicked} />
                    <NumpadRow values={["4", "5", "6"]} onClick={this.numberClicked} />
                    <NumpadRow values={["7", "8", "9"]} onClick={this.numberClicked} />
                    <div className="NumpadRow">
                        <Button variant="contained" onClick={this.clearClicked} className="tc-button tc-num-button2 clear">C</Button>
                        <NumberButton label="0" clicked={this.numberClicked} />
                        <Button variant="contained" onClick={this.okClicked} className="tc-button tc-num-button2 ok">Ok</Button>
                    </div>
                </div>
            </div>
        );
    }
}

interface NumpadRowProps {
    values: string[];
    onClick: (label: string) => void;
}

function NumpadRow(props: NumpadRowProps) {
    const { values, onClick } = props;

    return (
        <div className="NumpadRow">
            {values.map(i => (
                <NumberButton key={i} label={i} clicked={onClick} />
            ))}
        </div>
    );
}

export default injectIntl(Numpad);
